"use strict";

exports.__esModule = true;
exports.AggregateMeasureChartElement = void 0;
var _last2 = _interopRequireDefault(require("ramda/src/last"));
var _react = _interopRequireDefault(require("react"));
var _Utils = require("../../../Utils");
var _Translator = require("../../Core/Translator");
var _SelectedDevicesController = require("../../Device/SelectedDevicesController");
var _AggregateTimelineMetrics = require("../../Metrics/MetricQueryController/AggregateTimelineMetrics");
var _TimeContext = require("../../Time/TimeContext");
var _TimePeriodController = require("../../Time/TimePeriodController");
var _timeAggregationBinMapping = require("../../VIMANAMetrics/timeAggregationBinMapping");
var _errorHandler = require("../AggregateMeasureTable/errorHandler");
var _BarChart = require("../common/AggregateMetricCharts/BarChart");
var _ErrorText = require("../common/AggregateMetricCharts/ErrorText");
var _getTickXFormatter = require("../common/AggregateMetricCharts/getTickXFormatter");
var _getXValue = require("../common/AggregateMetricCharts/getXValue");
var _getYTickFormatter = require("../common/AggregateMetricCharts/getYTickFormatter");
var _getYValue = require("../common/AggregateMetricCharts/getYValue");
var _ScrollableChart = require("../common/AggregateMetricCharts/ScrollableChart");
var _MaxBinLimitWrapper = require("../common/MaxBinLimitWrapper");
var _formatToPlantTime = require("../common/utils/formatToPlantTime");
var _sortEventsByWorkdayStart = require("../common/utils/sortEventsByWorkdayStart");
var _WidgetLoadingSpinner = require("../common/WidgetLoadingSpinner");
var _getTimelineAggregateQuery = require("./getTimelineAggregateQuery");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getName = function getName(fieldName) {
  return (0, _last2["default"])(fieldName.split(".")).split(/[_-]/).map(function (word) {
    return (0, _Utils.capitalizeWords)([word]);
  }).join(" ");
};
var getData = function getData(aggregatedTimeline, windowType, color, fieldName, _ref) {
  var currentWorkday = _ref.currentWorkday,
    timezone = _ref.timezone;
  var timeline = aggregatedTimeline.map(function (aggregate) {
    return {
      key: "" + aggregate[(0, _timeAggregationBinMapping.getTimeGroupingBinName)(windowType)],
      color: color,
      value: aggregate[(0, _getTimelineAggregateQuery.getAggregationName)(fieldName)],
      unit: "number",
      name: getName(fieldName)
    };
  });
  if (windowType === _timeAggregationBinMapping.HOUR_PER_DAY) {
    return (0, _formatToPlantTime.formatToPlantTime)({
      data: timeline,
      timezone: timezone,
      binName: "key"
    });
  } else if (windowType === _timeAggregationBinMapping.HOUR_OF_DAY) {
    return (0, _sortEventsByWorkdayStart.sortEventsByWorkdayStart)(timeline, timezone.name, currentWorkday.interval.startMillis);
  }
  return timeline;
};
var createSeries = function createSeries(aggregatedTimeline, color, fieldName, windowType, timeProps) {
  return [{
    unit: getName(fieldName),
    color: "#00A796",
    data: getData(aggregatedTimeline, windowType, color, fieldName, timeProps),
    getXValue: function getXValue(item) {
      return item.key;
    },
    getYValue: function getYValue(item) {
      return item.value;
    },
    render: function render(props) {
      return /*#__PURE__*/_react["default"].createElement(_BarChart.BarChart, props);
    }
  }];
};
var AggregateMeasureChartElement = exports.AggregateMeasureChartElement = function AggregateMeasureChartElement(props) {
  var width = props.width,
    height = props.height,
    dataRange = props.dataRange,
    color = props.color,
    dateHistogram = props.dateHistogram,
    measureChartSeries = props.measureChartSeries,
    hideYLabel = props.hideYLabel,
    hideYAxis = props.hideYAxis,
    hideXAxis = props.hideXAxis,
    hideTooltip = props.hideTooltip,
    hideXLabel = props.hideXLabel;
  var timePeriod = (0, _TimePeriodController.useSelectionContext)({
    dataRange: dataRange
  });
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var _React$useContext2 = _react["default"].useContext(_TimeContext.TimeContext),
    currentWorkday = _React$useContext2.currentWorkday,
    timezone = _React$useContext2.timezone;
  var device = (0, _SelectedDevicesController.useSelectedDevices)();
  if (!(dateHistogram && dateHistogram.length)) {
    return /*#__PURE__*/_react["default"].createElement(_ErrorText.ErrorText, {
      width: width,
      height: height
    }, translate("AggregateMeasureChartElementProps.selectAggregation.helperText", "Please select time aggregation."));
  }
  if (!(measureChartSeries && measureChartSeries.length)) {
    return /*#__PURE__*/_react["default"].createElement(_ErrorText.ErrorText, {
      width: width,
      height: height
    }, translate("AggregateMeasureChartElementProps.selectMeasure.helperText", "Please select a measure."));
  }
  var fieldName = measureChartSeries[0].id;
  var windowType = dateHistogram[0];
  return /*#__PURE__*/_react["default"].createElement(_MaxBinLimitWrapper.MaxBinLimitWrapper, {
    timeAggregationName: windowType
  }, /*#__PURE__*/_react["default"].createElement(_AggregateTimelineMetrics.AggregateTimelineMetricQueryController, {
    query: (0, _getTimelineAggregateQuery.getTimelineAggregateQuery)({
      device: device,
      interval: timePeriod.interval,
      measureColumnIds: [fieldName],
      windowType: windowType,
      timezoneName: timezone.name,
      type: [measureChartSeries[0].dataSourceType]
    })
  }, function (loadingProps) {
    if (loadingProps.error) {
      return /*#__PURE__*/_react["default"].createElement(_errorHandler.HandleQueryError, {
        width: width,
        height: height,
        error: loadingProps.error
      });
    }
    if (loadingProps.fetching || !loadingProps.loaded) {
      return /*#__PURE__*/_react["default"].createElement(_WidgetLoadingSpinner.WidgetLoadingSpinner, {
        width: width,
        height: height
      });
    }
    var series = createSeries(loadingProps.data, color, fieldName, windowType, {
      timezone: timezone,
      currentWorkday: currentWorkday
    });
    var tickXFormatter = function tickXFormatter(xTickFormatterProps) {
      return (0, _getTickXFormatter.getXTickFormatter)(Object.assign({
        windowType: windowType
      }, xTickFormatterProps));
    };
    var getXValueInBandScale = (0, _getXValue.getXValueFormatterInBandScale)({
      windowType: windowType
    });
    return /*#__PURE__*/_react["default"].createElement(_ScrollableChart.ScrollableChart, {
      series: series,
      width: width,
      height: height,
      hideYAxis: hideYAxis,
      hideYUnits: hideYLabel,
      hideXAxis: hideXAxis,
      hideXUnits: hideXLabel,
      xAxisLabel: (0, _timeAggregationBinMapping.getTimeGroupingLabel)(windowType),
      tickXFormat: tickXFormatter,
      tickYFormat: _getYTickFormatter.getYTickFormatter,
      builtInTooltip: !hideTooltip,
      tooltipFormatters: {
        getXFormatter: getXValueInBandScale,
        getYFormatter: _getYValue.getYValueForBinnedData
      }
    });
  }));
};